<script>
  import { useLocation } from "svelte-navigator";
  import { fetchWrapper } from "lib/util/fetchWrapper.js";
  import { useUrlParams } from "@stores/urlStore.js";
  import { fade, fly } from "svelte/transition";
  import Header from "../../../lib/components/Header.svelte";
  import { SectionWrapper, TextInput } from "paxray-components-svelte";
  import Button from "../../../lib/components/Button.svelte";
  import { Checkbox } from "carbon-components-svelte";

  const urlParams = useUrlParams();
  let userid = "";
  let rawonly = true;
  let saveSuccessful = false;
  let loading = false;
  let error = false;

  // get the user id from the url
  $: userid = $urlParams.userid || "";

  function deleteUserData() {
    console.log("click");
    loading = true;
    fetchWrapper(`/api/damprojects/userDataDeletion`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userid: userid,
        rawonly: rawonly,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.success) {
          userid = "";
          rawonly = false;
          saveSuccessful = true;
          loading = false;
        } else {
          console.error("Error:", data.message);
          loading = false;
          error = true;
        }
      })
      .catch((err) => {
        console.error("Server error:", err);
        loading = false;
        error = true;
      });
  }

  $$restProps;
</script>

<Header section="Data Deletion" breadcrumb="User data"></Header>

<SectionWrapper fullscreen={true}>
  <div slot="main" class="main_wrapper">
    <div class="input_wrapper">
      <p>Userid:</p>
      <TextInput value={userid} readonly />
    </div>
    <div class="check_wrapper">
      <p>Row Data Only:</p>
      <Checkbox bind:checked={rawonly}></Checkbox>
    </div>
    <div class="button_wrapper">
      <Button
        on:click={deleteUserData}
        text="Delete"
        disabled={loading || !userid}
        notAllowed={loading || !userid}
        variant="secondary"
        setting={true}
        {loading}
      />
    </div>
  </div>
</SectionWrapper>

{#if saveSuccessful}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:fixed; top:50px; right:20px; z-index:9999;"
  ></div>
{/if}
{#if error}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:fixed; top:50px; right:20px; z-index:9999;"
  ></div>
{/if}

<style>
  .main_wrapper {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 80%;
    margin: 3rem;
  }

  .input_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    width: 100%;
  }

  .check_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
  }

  .input_wrapper p,
  .check_wrapper p {
    width: 120px;
    text-align: right;
    margin: 0;
  }

  .button_wrapper {
    margin-left: 140px;
  }
</style>
